import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-input-control',
  templateUrl: './input-control.component.html',
  styles: [
  ]
})
export class InputControlComponent {
  @Input() formName!: FormGroup;
  @Input() control!: AbstractControl;
  @Input() controlName!: string;
  @Input() label!: string;
  @Input() hideLabel!: boolean;
  @Input() maxLength!: number;
  @Input() minLength!: number;
  @Input() elementId!: string;
  @Input() inputType = 'text';
  @Input() placeholder = '';
  @Input() className?: string = '';
  @Input() tabIndex!: number;
  @Input() isAutoFocus = false;
  @Input() iTagData = '';

  @Output() blurEvent = new EventEmitter<string>();
  @Output() inputEvent = new EventEmitter<string>();
  @Output() keyupEvent = new EventEmitter<any>();

  get isRequired(): boolean {
    if (!this.control) return false;

    const validator = this.control.validator
      ? this.control.validator({} as AbstractControl)
      : null;
    if (validator && validator['required']) {
      return true;
    } else {
      return false;
    }
  }

  get isValid(): boolean | null {
    if (!this.control) return false;

    return this.control.status.toLowerCase() === 'invalid' ? true : null;
  }

  onBlur() {
    const value = this.control.value && this.control.value.trim();
    this.control.setValue(value);
    this.blurEvent.emit(value);
  }
  onInput() {
    const value = this.control.value && this.control.value.trim();
    this.inputEvent.emit(value);
  }

  onKeyup(event: KeyboardEvent) {
    this.keyupEvent.emit(event);
  }
}
